export interface MenuItem {
  title: string;
  url: string;
  description?: string;
  icon?: React.ReactNode;
  items?: MenuItem[];
}

// This is the content for the header, that lives in either the desktop or mobile header
export const headerMenu: MenuItem[] = [
  {
    title: "Quick Start",
    url: "/c/docs/quickstart",
  },
  {
    title: "Blog",
    url: "/blog",
  },
  /*  An example of a nested menu item
    {
      title: "Products",
      url: "#",
      items: [
        {
          title: "Blog",
          description: "The latest industry news, updates, and info",
          icon: <Book className="size-5 shrink-0" />,
          url: "#",
        },
        {
          title: "Company",
          description: "Our mission is to innovate and empower the world",
          icon: <Trees className="size-5 shrink-0" />,
          url: "#",
        },
      ],
    },
  ] ,
  */
];

export const userMenu: MenuItem[] = [
  {
    title: "API Keys",
    url: "/c/cloud/api-keys",
  },
  {
    title: "Playground",
    url: "/c/playground",
  },
];
